import axios from "axios";
import Config from "../../config";

const actionPesquisarChamados = ({ cliente_id, search, limit = 10 }) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chamados/pesquisar`,
        params: { cliente_id, search, limit }
    });
};

export default actionPesquisarChamados;
